<template>
  <v-breadcrumbs
    v-if="showOnRoutes"
    small
    class="breadcrums"
    :items="items"
    divider="/"
    :large="$vuetify.breakpoint.mdAndUp"
  >
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        ripple
        :href="item.href"
        @click.prevent="routeTo(item.to)"
        :disabled="item.disabled"
      >
        {{ item.text }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: 'Breadcrums',
  computed: {
    showOnRoutes() {
      switch (this.$route.name) {
        case 'Home':
          return false
        case '404':
          return false
        default:
          return true
      }
    },
    items() {
      let currentRoute = this.$route
      let res = [
        { text: 'Start', href: '#', disabled: false, to: { name: 'Home' } }
      ]

      if (
        currentRoute.name === 'om-livet' ||
        currentRoute.name === 'redaktion' ||
        currentRoute.name === 'medverkande-experter' ||
        currentRoute.name === 'engagera-dig' ||
        currentRoute.name === 'quiz'
      ) {
        res.push({
          text: 'Om livet',
          href: '#',
          disabled: false,
          to: { name: 'om-livet' }
        })
      }

      if (currentRoute.name === 'redaktion') {
        res.push({
          text: 'Redaktionen',
          href: '#',
          disabled: false,
          to: { name: 'redaktion' }
        })
      }

      if (currentRoute.name === 'medverkande-experter') {
        res.push({
          text: 'Medverkande experter',
          href: '#',
          disabled: false,
          to: { name: 'medverkande-experter' }
        })
      }
      if (currentRoute.name === 'engagera-dig') {
        res.push({
          text: 'Engagera dig',
          href: '#',
          disabled: false,
          to: { name: 'engagera-dig' }
        })
      }
      if (currentRoute.name === 'quiz') {
        res.push({
          text: 'Quiz',
          href: '#',
          disabled: false,
          to: { name: 'quiz' }
        })
      }

      if (
        currentRoute.name === 'Species' ||
        currentRoute.name === 'SpeciesCategory' ||
        currentRoute.name === 'SpeciesSubCategory' ||
        currentRoute.name === 'SingleSpecies' ||
        currentRoute.name === 'AlienSpecies' ||
        currentRoute.name === 'RedSpecies'
      ) {
        res.push({
          text: 'Arter',
          href: '#',
          disabled: false,
          to: { name: 'Species' }
        })
      }

      if (currentRoute.name === 'AlienSpecies') {
        res.push({
          text: 'Främmande arter',
          href: '#',
          disabled: false
        })
      }

      if (currentRoute.name === 'RedSpecies') {
        res.push({
          text: 'Rödlistade arter',
          href: '#',
          disabled: false
        })
      }

      if (
        currentRoute.name === 'SpeciesCategory' ||
        currentRoute.name === 'SpeciesSubCategory'
      ) {
        let categoryUrl = currentRoute.params.categoryNameUrl
        let categoryName = this.getCategoryNameByUrl(categoryUrl)
        res.push({
          text: categoryName,
          href: '#',
          disabled: false,
          to: {
            name: 'SpeciesCategory',
            params: { categoryNameUrl: categoryUrl }
          }
        })
      }

      if (currentRoute.name === 'SpeciesSubCategory') {
        let categoryUrl = currentRoute.params.categoryNameUrl
        let subCategoryUrl = currentRoute.params.subCategoryNameUrl
        let subCategoryName = this.getSubCategoryNameByUrl(subCategoryUrl)
        res.push({
          text: subCategoryName,
          href: '#',
          disabled: false,
          to: {
            name: 'SpeciesSubCategory',
            params: {
              categoryNameUrl: categoryUrl,
              subCategoryNameUrl: subCategoryUrl
            }
          }
        })
      }
      if (currentRoute.name === 'SingleSpecies') {
        let currentSpecies = this.getSingleSpecies(currentRoute.params.nameUrl)
        if (currentSpecies) {
          res.push({
            text: currentSpecies.category,
            href: '#',
            disabled: false,
            to: {
              name: 'SpeciesCategory',
              params: { categoryNameUrl: currentSpecies.category_url }
            }
          })

          res.push({
            text: currentSpecies.life_group,
            href: '#',
            disabled: false,
            to: {
              name: 'SpeciesSubCategory',
              params: {
                categoryNameUrl: currentSpecies.category_url,
                subCategoryNameUrl: currentSpecies.sub_category_url
              }
            }
          })

          res.push({
            text: currentSpecies.name_sve,
            href: '#',
            disabled: false
          })
        }
      }

      if (
        currentRoute.name === 'Livsmiljoer' ||
        currentRoute.name === 'grunda-klipp-och-stenbottnar' ||
        currentRoute.name === 'djupa-klipp-och-stenbottnar' ||
        currentRoute.name === 'grunda-mjuka-bottnar' ||
        currentRoute.name === 'djupa-mjuka-bottnar' ||
        currentRoute.name === 'det-fria-vattnet'
      ) {
        res.push({
          text: 'Livsmiljöer',
          href: '#',
          disabled: false,
          to: {
            name: 'Livsmiljoer'
          }
        })
      }
      if (
        currentRoute.name === 'grunda-klipp-och-stenbottnar' ||
        currentRoute.name === 'djupa-klipp-och-stenbottnar' ||
        currentRoute.name === 'grunda-mjuka-bottnar' ||
        currentRoute.name === 'djupa-mjuka-bottnar' ||
        currentRoute.name === 'det-fria-vattnet'
      ) {
        res.push({
          text: currentRoute.meta.miljoName,
          href: '#',
          disabled: false
        })
      }
      if (
        currentRoute.name === 'Fakta' ||
        currentRoute.name === 'att-leva-i-havet' ||
        currentRoute.name === 'ostersjons-historia' ||
        currentRoute.name === 'varken-salt-eller-sott' ||
        currentRoute.name === 'vem-ater-vem' ||
        currentRoute.name === 'vem-lever-var'
      ) {
        res.push({
          text: 'Faktasidor',
          href: '#',
          disabled: false,
          to: {
            name: 'Fakta'
          }
        })
      }
      if (
        currentRoute.name === 'att-leva-i-havet' ||
        currentRoute.name === 'ostersjons-historia' ||
        currentRoute.name === 'varken-salt-eller-sott' ||
        currentRoute.name === 'vem-ater-vem' ||
        currentRoute.name === 'vem-lever-var'
      ) {
        res.push({
          text: currentRoute.meta.factName,
          href: '#',
          disabled: false
        })
      }
      res = res.filter(r => r.text !== '')
      res.slice(-1)[0].disabled = true // set the last one to disabled
      return res
    }
  },
  methods: {
    getSingleSpecies(url) {
      const res = this.$store.state.allSpecies
      const species = res.find(species => species.url === url)
      return species
    },
    getCategoryNameByUrl(url) {
      const categories = this.$store.state.categories
      return categories.find(cat => cat.url.toLowerCase() === url.toLowerCase())
        ? categories.find(cat => cat.url.toLowerCase() === url.toLowerCase())
            .name
        : ''
    },
    getSubCategoryNameByUrl(url) {
      const subCategories = this.$store.state.subCategories
      const subCategory = subCategories.find(
        cat => cat.sub_category_url.toLowerCase() === url.toLowerCase()
      )
      return subCategory ? subCategory.sub_category : ''
    },
    routeTo(route) {
      this.$router.push(route)
    }
  }
}
// <router-link :to="{ name: 'user', params: { userId: 123 }}">User</router-link>
</script>

<style lang="scss" scoped>
.breadcrums {
  margin: 0;
  padding: 0;
}
</style>
